import type { LoaderFunction, LoaderFunctionArgs } from "react-router-dom";

const loaderCache = new Map<string, unknown>();

export const cachedLoader = (
  key: string | ((args: LoaderFunctionArgs) => string),
  loader: LoaderFunction,
) => {
  return async (args: LoaderFunctionArgs) => {
    const cacheKey = typeof key === "function" ? key(args) : key;
    if (loaderCache.has(cacheKey)) {
      return loaderCache.get(cacheKey);
    }

    const result = await loader(args);
    loaderCache.set(cacheKey, result);
    return result;
  };
};
